<template>
  <v-app>
    <v-alert type="warning" v-if="errors.length">
      <ul class="list">
        <li v-for="error in errors">У группы {{ error }} есть пропушенные данные</li>
      </ul>
    </v-alert>
    <v-card>
      <v-card-title>
        Группы
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="groups"
          :search="search"
          item-key="id"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
              color="blue darken-1"
              text
              @click="enterExams(item)"
          >
            Редактировать
          </v-btn>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-dialog
            v-model="destroyDialog"
            persistent
            max-width="310"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
            >
              Удалить все экзамены
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5">
              Удалить все экзамены из текущего шаблона?
            </v-card-title>
            <v-card-text>Соглашаясь вы удалите все экзамены из текущего шаблона для расписания. <b>Удаление экзаменов невозможно обратить</b></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="destroyDialog = false"
              >
                Отмена
              </v-btn>
              <v-btn
                  color="green darken-1"
                  text
                  @click="delAllExams"
              >
                Удалить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
    <v-dialog
        v-model="editExamsDialog"
        persistent
        max-width="1600"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Расписание группы {{timetable.name}}</span>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
            <tr>
              <th class="text-left">
                Дата
              </th>
              <th class="text-left">
                Время
              </th>
              <th class="text-left">
                Дисциплина
              </th>
              <th class="text-left">
                Аудитория
              </th>
              <th class="text-left">
                Преподаватель
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in timetable.exams">
              <td>
                <v-menu
                    v-model="item.menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="computedDate(item.exam_date)"
                      clearable
                      label="Дата"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="item.exam_date = null"
                  ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="item.exam_date"
                      @input="item.menu = false"
                      locale="ru-RU"
                  ></v-date-picker>
                </v-menu>
              </td>
              <td>
                <v-text-field
                    v-model="item.time"
                    label="Время"
                ></v-text-field>
              </td>
              <td>
                <v-autocomplete
                    label="Дисциплина"
                    :items="disciplines"
                    item-text="label"
                    item-value="id"
                    v-model="item.discipline_id"
                >
                </v-autocomplete>
              </td>
              <td>
                <v-autocomplete
                    label="Аудитория"
                    :items="classrooms"
                    item-text="label"
                    item-value="id"
                    v-model="item.classroom_id"
                >
                </v-autocomplete>
              </td>
              <td>
                <v-autocomplete
                    label="Преподаватель"
                    :items="teachers"
                    item-text="label"
                    item-value="id"
                    v-model="item.person_id"
                >
                </v-autocomplete>
              </td>
              <td>
                <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="error"
                    v-on:click="delExam(timetable.exams.indexOf(item))">
                  <v-icon dark>
                    fa-trash
                  </v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <th>
              <v-btn
                  class="mx-2"
                  fab
                  dark
                  x-small
                  color="success"
                  v-on:click="addExam">
                <v-icon dark>
                  fa-plus
                </v-icon>
              </v-btn>
            </th>
            </tfoot>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="red darken-1"
              text
              @click="editExamsDialog = false"
          >
            Закрыть
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="saveExams"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>

import axios from "axios";
import Vue from 'vue';
import _ from "lodash";
import 'moment/locale/ru';
import moment from "moment";

export default {
  name: 'exam_index',
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Группа',
        align: 'start',
        value: 'name',
      },
      { text: 'Экзаменов', value: 'exams', sortable: false, filterable: false },
      { text: 'Редактировать', value: 'actions', sortable: false, filterable: false, align: 'center' },
    ],
    menu: false,
    modal: false,
    groups: [],
    teachers: [],
    classrooms: [],
    disciplines: [],
    template: 0,
    editExamsDialog: false,
    destroyDialog: false,
    timetable: {id: 0, name: '', exams: [] },
    errors: []
  }),

  computed:{

  },

  methods: {
    computedDate (item) {
      return item ? moment(item).format('DD MMMM YYYY') : ''
    },
    needDate(){
      this.timetable.exams.forEach(item => {
        item.exam_date = (new Date( new Date(item.exam_date) - (new Date()) * 60000)).toISOString().substr(0, 10)
      })
    },
    getInfo() {
      axios({
        method: 'get',
        url: `/timetable/templates/${this.template}/exam_index.json`,
      }).then((response) => {
        this.groups = response.data.groups;
        this.classrooms = response.data.classrooms;
        this.disciplines = response.data.disciplines;
        this.teachers = response.data.teachers;
        this.errors = response.data.errors;
      }).catch((error) => {
        return error;
      });
    },
    enterExams(item){
      this.editExamsDialog = true
      this.timetable.id = item.id
      this.timetable.name = item.name
      axios({
        method: 'get',
        url: `/timetable/templates/${this.template}/exams/${item.id}`,
      }).then((response) => {
        this.timetable.exams = response.data.exams;
        this.disciplines = this.disciplines.concat(response.data.disciplines);
        this.needDate()
      }).catch((error) => {
        return error;
      })
    },
    addExam() {
      this.timetable.exams.push(
          {
            classroom_id: '',
            discipline_id: '',
            person_id: '',
            exam_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            time: '8:15',
            menu: false
          }
      )
    },
    delExam(index){
      this.timetable.exams.splice(index, 1)
    },
    delAllExams(){
      this.destroyDialog = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios.delete(`/timetable/templates/${this.template}/delete_all_exams`)
      this.getInfo()
    },
    saveExams(){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'post',
        url: `/timetable/templates/${this.template}/save_exams`,
        data: {
          exams: this.timetable
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.getInfo()
          this.editExamsDialog = false
        }
      }).catch((error) => {
        return error;
      });
    },

  },
  mounted() {
    this.template = window.location.pathname.split('/')[3]
    this.getInfo()
  }
}
</script>
